// The product brand, typed. Source of truth: ../brand.json (see its _doc and handoff §8a).
// Web and mobile import from here; never write the product name, domain or brand colors as literals.
import manifest from '../brand.json';

export type PaletteTokens = (typeof manifest.colors)['light'];
export type ColorMode = keyof typeof manifest.colors;

const primaryDomain = manifest.domains[0];
const mailbox = (local: string) => `${local}@${primaryDomain}`;

export const brand = {
  name: manifest.name,
  legalEntity: manifest.legalEntity,
  tagline: manifest.tagline,
  domains: manifest.domains,
  primaryDomain,
  appHost: manifest.appHost,
  appUrl: `https://${manifest.appHost}`,
  supportEmail: mailbox(manifest.mailboxes.support),
  noreplyEmail: mailbox(manifest.mailboxes.noreply),
  privacyEmail: mailbox(manifest.mailboxes.privacy),
  legalEmail: mailbox(manifest.mailboxes.legal),
  titles: manifest.titles,
  fonts: manifest.fonts,
} as const;

export const palette: Record<ColorMode, PaletteTokens> = manifest.colors;
